import { render, staticRenderFns } from "./joinRecord.vue?vue&type=template&id=c34b71a4&scoped=true"
import script from "./joinRecord.vue?vue&type=script&lang=js"
export * from "./joinRecord.vue?vue&type=script&lang=js"
import style0 from "./joinRecord.vue?vue&type=style&index=0&id=c34b71a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34b71a4",
  null
  
)

export default component.exports